import { Enrollment } from "../../shared/Utils/Enrollment";

export  enum ReportCategoryEnum {
    Order  =  101,
    POS  =  102,
    Autoship = 103,
    GovernmentID = 104,
    Enrollment = 112
}

export enum ReportCategoryNameEnum{
    SEPA = 'SEPA'
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/report-category.enum.ts